import { render } from "./InstructorDetailsView.vue?vue&type=template&id=4a655ff6&scoped=true"
import script from "./InstructorDetailsView.vue?vue&type=script&lang=js"
export * from "./InstructorDetailsView.vue?vue&type=script&lang=js"

import "./InstructorDetailsView.vue?vue&type=style&index=0&id=4a655ff6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a655ff6"]])

export default __exports__